import Util from "./Util.js";
//
import { gsap } from "./Util.js";

class Mouse extends Util {
  constructor() {
    super();
    this.init();
  }

  init() {
    this.setVars();
    this.events();
    this.startRaf();
  }

  setVars() {
    this.cursorDOM = document.getElementById("cursor");
    this.mouseX = 0;
    this.mouseY = 0;
    this.cursorX = 0;
    this.cursorY = 0;
    this.isHover = false;
    this.ease = 0.25;
  }

  events() {
    let dom = this.cursorDOM;

    if (!this.website.isDesktop) {
      return;
    }

    dom.classList.remove("is-view");
    dom.classList.remove("is-next");
    dom.classList.remove("is-prev");

    window.addEventListener("mousemove", this.getPos.bind(this));

    const cursorInElements = document.querySelectorAll(".cursor-in");

    cursorInElements.forEach((element) => {
      element.removeEventListener("mouseenter", handleMouseEvents);
      element.removeEventListener("mouseleave", handleMouseEvents);
      element.removeEventListener("mousemove", handleMouseEvents);
      element.addEventListener("mouseenter", handleMouseEvents);
      element.addEventListener("mouseleave", handleMouseEvents);
      element.addEventListener("mousemove", handleMouseEvents);
    });

    function handleMouseEvents(e) {
      const that = e.currentTarget;
      if (e.type === "mousemove" || e.type === "mouseenter") {
        if (that.getAttribute("data-type") === "view") {
          dom.classList.add("is-view");
        } else if (that.getAttribute("data-type") === "next") {
          dom.classList.add("is-next");
        } else if (that.getAttribute("data-type") === "prev") {
          dom.classList.add("is-prev");
        }
      } else {
        dom.classList.remove("is-view");
        dom.classList.remove("is-next");
        dom.classList.remove("is-prev");
      }
    }
  }

  getPos(e) {
    this.mouseX = e.clientX;
    this.mouseY = e.clientY;
  }

  startRaf() {
    let that = this;
    const raf = () => {
      this.cursorX += (this.mouseX - this.cursorX) * this.ease;
      this.cursorY += (this.mouseY - this.cursorY) * this.ease;
      gsap.set(this.cursorDOM, {
        x: this.cursorX,
        y: this.cursorY,
      });

      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
  }
}

export default Mouse;
